<template>
  <div class="content pr-2">
    <h1 class="has-text-centered">
      Contact Us
    </h1>
    <hr>
    <div class="columns">
      <div class="column is-8">
        <strong>We want to address any question or concern you have as quickly as possible.<br>
          Please select the appropriate department from the list below.</strong><br>
        <div class="field has-addons">
          <div class="control is-fullwidth">
            <div
              class="dropdown is-fullwidth"
              :class="{'is-active': isActive}"
              @click="isActive = !isActive"
            >
              <div class="dropdown-trigger is-fullwidth">
                <button
                  class="button is-fullwidth"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                >
                  <span>{{ activeTheme.charAt(0).toUpperCase() + activeTheme.slice(1) }}</span>
                  <span class="icon is-small">
                    <i
                      class="far fa-angle-down"
                      aria-hidden="true"
                    />
                  </span>
                </button>
              </div>
              <div
                id="dropdown-menu"
                class="dropdown-menu is-fullwidth"
                role="menu"
              >
                <div class="dropdown-content">
                  <a
                    v-for="theme in themes"
                    class="dropdown-item"
                    @click="switchActiveTheme(theme)"
                  >{{ theme.charAt(0).toUpperCase() + theme.slice(1) }}</a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="control"
            @click="showForm()"
          >
            <a class="button">
              <span class="icon is-small">
                <i class="far fa-envelope" />
              </span>
              <span>E-mail</span>
            </a>
          </div>
        </div>
        <p>
          At AHL nothing is more important than our members and we are happy to address any question or concern that you may have. To ensure you receive a quick response or resolution please make sure to contact the department that most closely matches your question, concern or need.
        </p><p>
          Our office hours are Monday to Saturday 8am to 5pm CST. If you contact us after hours someone will get back to you the following day. 
        </p>
        <p class="has-text-centered">
          Do you own or manage a bar or restaurant?<br>
          Are you looking for a way to increase sales?<br>
          Click the button below to bring AHL Poker to your location!
        </p>
        <div class="columns">
          <div class="column is-12 has-text-centered text-white">
            <router-link
              :to="{path: '/hire-ahl-poker'}"
              class="button is-info is-block white-text"
            >
              BRING AHL TO YOUR VENUE
            </router-link>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="box">
          <strong>Adam Thompson <router-link
            :to="{path: `/players/00001606`}"
            class="is-pulled-right"
          >00001606</router-link></strong>
          <div class="is-clearfix" />
          <span>CEO/Founder</span>
        </div>
        <div class="box">
          <strong>Chris White <router-link
            :to="{path: `/players/00001678`}"
            class="is-pulled-right"
          >00001678</router-link></strong>
          <div class="is-clearfix" />
          <span>CTO / Online Operations</span>
        </div>
        <div class="box">
          <strong>Jerry Wolski <router-link
            :to="{path: `/players/00001600`}"
            class="is-pulled-right"
          >00001600</router-link></strong>
          <div class="is-clearfix" />
          <span>Founder</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.content .white-text {
  color: white !important;
}
</style>
<script>
  export default {
    name: 'Contact',
    metaInfo: {
      title: 'AHL Poker :: Contact'
    },
    data () {
      return {
        themes: [
          'points',
          'help',
          'feedback',
          'ideas',
          'events',
          'complaints',
          'website',
          'support',
          'advertisement',
          'employment'
        ],
        activeTheme: 'Points',
        isActive: false
      }
    },
    computed: {},
    methods: {
      showForm () {
        this.$router.push({name: 'ContactForm', params: {theme: this.activeTheme}})
      },
      switchActiveTheme (theme) {
        this.activeTheme = theme
      }
    }
  }
</script>
